<div class="modal-body">
  <p>{{ dialogData.data.para }}</p>
  <div *ngIf="currentSubcompany == ''">   
    <p>
      <span [innerHTML]="dialogData.data.phone" class="tel"></span>
      <br />
      <span [innerHTML]="dialogData.data.email"></span>
    </p>    
    <span [innerHTML]="dialogData.data.claimContact"></span>
  </div> 
  <div *ngIf="currentSubcompany == 'General Liability'">
    <p>
      <span [innerHTML]="dialogData.data.ARC_Info"></span>
    </p>
  </div>
  <div *ngIf="currentSubcompany == 'Excess Liability'">
    <p>
      <span [innerHTML]="dialogData.data.AXL_Info"></span>
    </p>
  </div>  
  <div *ngIf="currentSubcompany == 'Builders Risk'">    
    <span [innerHTML]="dialogData.data.BR_Info"></span>
  </div>
  <div *ngIf="currentSubcompany == 'Contractors Equipment'">    
    <span [innerHTML]="dialogData.data.CE_Info"></span>
  </div>
  <div *ngIf="currentSubcompany == 'Professional Liability'">    
    <span [innerHTML]="dialogData.data.AECP_Info"></span>
  </div>
  

  <div *ngIf="!renewalflag && !ceContactFlad">
    <button
      *ngIf="dialogData.data.showFooterBtn"
      class="btn btn-primary test"
      (click)="callback()"
    >
      {{ dialogData.data.footerBtnLabel }}
    </button>
  </div>
  <div *ngIf="renewalflag || ceContactFlad">
    <button
      *ngIf="dialogData.data.showFooterBtn"
      class="btn btn-primary"
      (click)="closePopup()"
    >
      {{ dialogData.data.noBtnLabel }}
    </button>
    <button
      *ngIf="dialogData.data.showFooterBtn"
      [class]="ceContactFlad ? 'btn btn-danger mar-top-10' : 'btn btn-primary'"
      (click)="yesPopup()"
    >
      {{ dialogData.data.yesBtnLabel }}
    </button>
  </div>
</div>
